<template>
  <div>
    <!-- 微信支付弹窗 -->
    <el-dialog
      title="请用扫码枪扫码"
      :visible.sync="wxPayVisible"
      width="60%"
      :before-close="handleWxClose"
    >
      <el-form label-width="120px">
        <el-form-item label="总金额：">
          <span style="font-size: 25px; color: red;">￥{{goodCashierConfirm.preMoney}}</span>
        </el-form-item>
        <el-form-item label="消费积分：">
          <span style="font-size: 25px; color: red;">{{goodCashierConfirm.bonusPoints}}</span>
        </el-form-item>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠方式：">
              <el-select 
                v-model="goodCashierConfirm.discountType" 
                placeholder="请选择优惠方式"
                style="width: 100%;"
              >
                <el-option label="打折" value="1001"></el-option>
                <el-option label="减免" value="2002"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="goodCashierConfirm.discountType=='1001'">
            <el-form-item label="打折率：">
              <el-input 
                v-model="goodCashierConfirm.discountRate" 
                @blur="_goodCashierConfirmComputeMoney"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="goodCashierConfirm.discountType=='2002'">
            <el-form-item label="减免金额：">
              <el-input 
                v-model="goodCashierConfirm.discountPrice" 
                @blur="_goodCashierConfirmComputeMoney"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="应收金额：">
          <span style="font-size: 25px; color: red;">￥{{goodCashierConfirm.money}}</span>
        </el-form-item>
        
        <el-form-item label="支付信息：">
          <el-input 
            v-model="goodCashierConfirm.authCode" 
            placeholder="必填，请填写支付信息，扫码枪扫入"
            @keyup.enter.native="_doPayWxCarsh"
            ref="wxAuthCode"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_closeWxPayCarsh">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 现金支付弹窗 -->
    <el-dialog
      title="结算确认"
      :visible.sync="cashPayVisible"
      width="60%"
      :before-close="handleCashClose"
    >
      <el-form label-width="120px">
        <el-form-item label="总金额：">
          <span style="font-size: 25px; color: red;">￥{{goodCashierConfirm.preMoney}}</span>
        </el-form-item>
        <el-form-item label="消费积分：">
          <span style="font-size: 25px; color: red;">{{goodCashierConfirm.bonusPoints}}</span>
        </el-form-item>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="优惠方式：">
              <el-select 
                v-model="goodCashierConfirm.discountType" 
                placeholder="请选择优惠方式"
                style="width: 100%;"
              >
                <el-option label="打折" value="1001"></el-option>
                <el-option label="减免" value="2002"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="goodCashierConfirm.discountType=='1001'">
            <el-form-item label="打折率：">
              <el-input 
                v-model="goodCashierConfirm.discountRate" 
                @blur="_goodCashierConfirmComputeMoney"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="goodCashierConfirm.discountType=='2002'">
            <el-form-item label="减免金额：">
              <el-input 
                v-model="goodCashierConfirm.discountPrice" 
                @blur="_goodCashierConfirmComputeMoney"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="实收金额：">
          <el-input-number 
            v-model="goodCashierConfirm.receivableMoney" 
            :min="0.01" 
            @change="_changeReceivableMoney"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        
        <el-form-item label="找零：">
          <span style="font-size: 25px; color: red;">￥{{goodCashierConfirm.givechange}}</span>
        </el-form-item>
        
        <el-form-item label="应收金额：">
          <span style="font-size: 25px; color: red;">￥{{goodCashierConfirm.money}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_closePayCarsh">关闭</el-button>
        <el-button type="primary" @click="_payCarsh">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//import { goodCashierToPay, checkGoodCashierToPay, goodFaceToFaceCashierToPay } from '@/api/goods/goodCashierConfirmApi'

export default {
  name: 'GoodCashierConfirm',
  data() {
    return {
      wxPayVisible: false,
      cashPayVisible: false,
      goodCashierConfirm: {
        authCode: '',
        preMoney: 0.0,
        money: 0.0,
        bonusPoints: 0.0,
        lastmoney: 0.0,
        productStocks: [],
        vipUser: {},
        discountType: '1001',
        discountRate: '1',
        discountPrice: 0,
        receivableMoney: 0.0,
        givechange: 0,
        hideModal: false,
        tmpParam: {}
      }
    }
  },
  methods: {
    open(goodCashierInfo) {
      this.clearConfirm()
      if (goodCashierInfo.vipUser.integralAmount < goodCashierInfo.bonusPoints) {
        this.$message.error('会员积分不足')
        return
      }
      if (goodCashierInfo.bonusPoints == 0 && goodCashierInfo.money == 0) {
        this.$message.error('请先选择商品')
        return
      }
      
      Object.assign(this.goodCashierConfirm, goodCashierInfo)
      this.goodCashierConfirm.preMoney = goodCashierInfo.money
      this.goodCashierConfirm.receivableMoney = goodCashierInfo.money
      this.cashPayVisible = true
    },
    
    openWxCarsh(goodCashierInfo) {
      this.clearConfirm()
      if (goodCashierInfo.vipUser.integralAmount < goodCashierInfo.bonusPoints) {
        this.$message.error('会员积分不足')
        return
      }
      if (goodCashierInfo.money == 0) {
        this.$message.error('请先选择商品，只有积分商品使用结算功能！')
        return
      }
      
      Object.assign(this.goodCashierConfirm, goodCashierInfo)
      this.goodCashierConfirm.preMoney = goodCashierInfo.money
      this.goodCashierConfirm.receivableMoney = goodCashierInfo.money
      this.goodCashierConfirm.authCode = ''
      this.wxPayVisible = true
      
      this.$nextTick(() => {
        this.$refs.wxAuthCode.focus()
      })
    },
    
    _doPayWxCarsh() {
      console.log('_doPayWxCarsh')
    },
    
    _doCheckPayWxCarsh() {
      console.log('_doCheckPayWxCarsh')
    },
    
    _closePayCarsh() {
      this.cashPayVisible = false
    },
    
    _payCarsh() {
      console.log('_payCarsh')
    },
    
    _goodCashierConfirmComputeMoney() {
      console.log('_goodCashierConfirmComputeMoney')
    },
    
    _changeReceivableMoney() {
      console.log('_changeReceivableMoney')
    },
    
    _closeWxPayCarsh() {
      this.wxPayVisible = false
    },
    
    clearConfirm() {
      this.goodCashierConfirm = {
        authCode: '',
        preMoney: 0.0,
        money: 0.0,
        bonusPoints: 0.0,
        lastmoney: 0.0,
        productStocks: [],
        vipUser: {},
        discountType: '1001',
        discountRate: '1',
        discountPrice: 0,
        receivableMoney: 0.0,
        givechange: 0,
        hideModal: false,
        tmpParam: {}
      }
    },
    
    handleWxClose(done) {
      this._closeWxPayCarsh()
      done()
    },
    
    handleCashClose(done) {
      this._closePayCarsh()
      done()
    }
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>